import z from "zod"

const MoneySchema = z.object({
  amount: z.string(),
  currency_code: z.string(),
})

const MoneyBagSchema = z.object({
  presentment_money: MoneySchema,
})

const CompensationSummarySchema = z.object({
  adjusted_commitment: MoneyBagSchema.nullish(),
  executed: MoneyBagSchema.nullish(),
  timing: z.string().nullish(),
})

const CompensationChannelSchema = z.object({
  summary: CompensationSummarySchema.nullish(),
})

const ReturnSummarySchema = z.object({
  basic_process_data: z.object({
    customer_printed_order_id: z.string(),
    order_id: z.string(),
    order_name: z.string().nullish(),
    order_purchased_at: z.string().nullish(),
    process_id: z.string(),
    started_at: z.string().nullish(),
  }),
  compensation: z
    .object({
      bank_transfer: CompensationChannelSchema.nullish(),
      gift_card: CompensationChannelSchema.nullish(),
      original_payment_method: CompensationChannelSchema.nullish(),
      promocode: CompensationChannelSchema.nullish(),
    })
    .nullish(),
  currency_code: z.string().nullish(),
  customer: z
    .object({
      address: z
        .object({
          country_code: z.string().nullish(),
          phone: z.string().nullish(),
        })
        .nullish(),
      email: z.string().nullish(),
      first_name: z.string().nullish(),
      last_name: z.string().nullish(),
    })
    .nullish(),
  extra_line_items: z
    .object({
      total: MoneyBagSchema.nullish(),
    })
    .nullish(),
  refund_payment_method: z.string().nullish(),
  returned_items: z
    .object({
      returned_items: z
        .array(
          z.object({
            action: z.string().nullish(),
            platform_line_item_id: z.string().nullish(),
            product_info: z
              .object({
                product_id: z.string().nullish(),
                product_name: z.string().nullish(),
                product_reference: z.string().nullish(),
                sku: z.string().nullish(),
              })
              .nullish(),
            quantity: z.number().nullish(),
            return_reason_comment: z.string().nullish(),
            return_reason_key: z.string().nullish(),
            rever_id: z.string().nullish(),
            total: MoneyBagSchema.nullish(),
            unit_price: MoneyBagSchema.nullish(),
          }),
        )
        .default([]),
      total: MoneyBagSchema.nullish(),
    })
    .nullish(),
  status: z.string(),
})

export const GetReverReturnResponseSchema = z.object({
  return_summary: ReturnSummarySchema,
})

export const ReverIntegrationResponseDataSchema = z.object({
  apiKey: z.string().nullish(),
})
